import { Injectable } from "@angular/core";

import { MapperInterface } from "../mapper-inteface";

import { DocumentoGescorDTO } from "@app/shared/dto/gescor/documeto-gescorDTO";

import { DocumentoGescorVO } from "@app/shared/vo/gescor/documento-gescorVO";

import { MapperDatiPersonali } from "../mapper-dati-personali";

import { MapperAutore } from "../mapper-autore";

import { MapperDatiFirma } from "../mapper-dati-firma";

import { MapperCampoSpecificoFascicolo } from "../mapper-campo-specifico-fascicolo";

import { MapperTipologiaDocumento } from "../mapper-tipologia-documento";

@Injectable({
  providedIn: "root",
})
export class MapperDocumentoGescor
  implements MapperInterface<DocumentoGescorDTO, DocumentoGescorVO> {
  constructor(
    private mapperDatiPrivacy: MapperDatiPersonali,
    private autoreMapper: MapperAutore,
    private datiFirmaMapper: MapperDatiFirma,
    private mapperCampoSpecificoFascicolo: MapperCampoSpecificoFascicolo,
    private mapperTipologiaDocumento: MapperTipologiaDocumento
  ) {}
  convertVoToDto(vo: DocumentoGescorVO): DocumentoGescorDTO {
    if (vo != null) {
      const dto = new DocumentoGescorDTO();
      dto.hash = vo.hash;
      dto.nome = vo.nome;
      dto.id = vo.id;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: DocumentoGescorDTO): DocumentoGescorVO {
    if (dto != null) {
      const vo = new DocumentoGescorVO();
      vo.hash = dto.hash;
      vo.nome = dto.nome;
      vo.id = dto.id;
      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(e: DocumentoGescorVO[]): DocumentoGescorDTO[] {
    if (e != null) {
      return e.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }
  convertListDtoToVo(t: DocumentoGescorDTO[]): DocumentoGescorVO[] {
    if (t != null) {
      return t.map((vo) => this.convertDtoToVo(vo));
    } else {
      return null;
    }
  }
}
